import './polyfills'; // Importa polyfills primeiro
import React from 'react';
//import 'bootstrap/dist/css/bootstrap.min.css';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';
import { isIEA } from './utils/isIEA';
import { isToolbox } from './utils/isToolbox';

const publicUrl = process.env.PUBLIC_URL || '';

if (isToolbox()) {
  document.title = 'Toolbox Teacher';
} else if (isIEA()) {
  document.title = 'IEA Teacher';
} else {
  document.title = 'Rock Teacher';
}

// Favicon dinâmico conforme ambiente
const linkIcon = document.querySelector('link[rel="icon"]');
if (linkIcon) {
  if (isToolbox()) {
    linkIcon.href = `${publicUrl}/favicon.png`;
  } else if (isIEA()) {
    linkIcon.href = `${publicUrl}/favicon_IEA.png`;
  } else {
    linkIcon.href = `${publicUrl}/favicon.png`;
  }
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
